import { render, staticRenderFns } from "./ques51.vue?vue&type=template&id=245157c3&scoped=true"
import script from "./ques51.vue?vue&type=script&lang=js"
export * from "./ques51.vue?vue&type=script&lang=js"
import style0 from "./ques51.vue?vue&type=style&index=0&id=245157c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245157c3",
  null
  
)

export default component.exports